<template>
    <div>
        <!-- Modal Doc Certificados -->
        <div class="modal fade" id="verDocCertModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documentos Certificados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="dados">
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between" v-for="(item, idx) in dados.doc_certificados" :key="idx">
                                <a :href="item.arquivo.temporary_url" class="card-link" target="_blank">
                                    {{ item.arquivo.usuario.st_login }}
                                </a>    
                                <a href="#" @click.prevent="remover_anexo(item)" v-if="item.arquivo.id_usuario == $store.state.user.id_usuario && item.arquivo.id_usuario != dados.id_usuario">
                                    <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; 

export default {
    data() {
        return {
            dados: null
        }
    },

    methods: { 
        abrir (docs) { 
            this.dados = _.cloneDeep(docs);
             $('#verDocCertModal').modal('show');
        },

        remover_anexo(arq) {
            if (!confirm("Confirma remover o documento assinado?")) {
                return;
            }

            this.$util.atualizar(this, {
                service: "arquivos",
                func: "destroy",
                dados: {
                    id: arq.id_arquivo_link
                },
                modal: 'verDocCertModal',
                callback: () => {
                    this.$emit("refresh");
                }
            });
        },
    }
}
</script>
